import { render, staticRenderFns } from "./MyAttention.vue?vue&type=template&id=31fe856b&scoped=true&"
import script from "./MyAttention.vue?vue&type=script&lang=js&"
export * from "./MyAttention.vue?vue&type=script&lang=js&"
import style0 from "./MyAttention.vue?vue&type=style&index=0&id=31fe856b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe856b",
  null
  
)

export default component.exports